import { createSlice } from '@reduxjs/toolkit';
import enumsOperations from './enums-operations';
import errorCodes from '../../shared/errorCodes/errorCodes';

const handlePending = state => {
  state.isLoading = true;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  const errorCode = action.payload;
  state.error = errorCodes[errorCode] || errorCode;
};

const enumsSlice = createSlice({
  name: 'enums',
  initialState: {
    enumsListSkills: [],
    enumsListSpecializations: [],
    enumsListCategories: [],
    enumsListDisorders: [],
    oneEnum: {},
    totalSkills: null,
    totalSpecializations: null,
    totalDisorders: null,
    totalCategories: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    partnersClearError: state => {
      state.error = null;
    },
  },

  extraReducers: builder => {
    builder
      .addCase(enumsOperations.fetchAllEnums.pending, handlePending)
      .addCase(enumsOperations.fetchAllEnums.fulfilled, (state, action) => {
        if (action.meta.arg.type === 'skills') {
          state.enumsListSkills = action.payload.data;
          state.totalSkills = action.payload.total;
        }
        if (action.meta.arg.type === 'categories') {
          state.enumsListCategories = action.payload.data;
          state.totalCategories = action.payload.total;
        }
        if (action.meta.arg.type === 'specializations') {
          state.enumsListSpecializations = action.payload.data;
          state.totalSpecializations = action.payload.total;
        }
        if (action.meta.arg.type === 'disorders') {
          state.enumsListDisorders = action.payload.data;
          state.totalDisorders = action.payload.total;
        }
        state.isLoading = false;
        state.error = null;
      })
      .addCase(enumsOperations.fetchAllEnums.rejected, handleRejected)

      //   .addCase(
      //     partnersOperations.fetchAllPartnersByQuery.pending,
      //     handlePending
      //   )
      //   .addCase(
      //     partnersOperations.fetchAllPartnersByQuery.fulfilled,
      //     (state, action) => {
      //       state.partnersList = action.payload.partners;
      //       state.total = action.payload.total;
      //       state.isLoading = false;
      //       state.error = null;
      //     }
      //   )
      //   .addCase(
      //     partnersOperations.fetchAllPartnersByQuery.rejected,
      //     handleRejected
      //   )

      .addCase(enumsOperations.fetchOneEnum.pending, handlePending)
      .addCase(enumsOperations.fetchOneEnum.fulfilled, (state, action) => {
        state.oneEnum = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(enumsOperations.fetchOneEnum.rejected, handleRejected)

      .addCase(enumsOperations.addNewEnum.pending, handlePending)
      .addCase(enumsOperations.addNewEnum.fulfilled, (state, action) => {
        const type = action.meta.arg.dataBody.type;

        if (type === 'skills') {
          state.enumsListSkills.push(action.payload);
        }
        if (type === 'categories') {
          state.enumsListCategories.push(action.payload);
        }
        if (type === 'specializations') {
          state.enumsListSpecializations.push(action.payload);
        }
        if (type === 'disorders') {
          state.enumsListDisorders.push(action.payload);
        }

        state.isLoading = false;
        state.error = null;
      })
      .addCase(enumsOperations.addNewEnum.rejected, handleRejected)

      //   .addCase(partnersOperations.deletePartner.pending, handlePending)
      //   .addCase(partnersOperations.deletePartner.fulfilled, (state, action) => {
      //     const index = state.partnersList.findIndex(
      //       item => item._id === action.meta.arg
      //     );
      //     state.partnersList.splice(index, 1);
      //     state.isLoading = false;
      //     state.error = false;
      //   })
      //   .addCase(partnersOperations.deletePartner.rejected, handleRejected)

      //   .addCase(partnersOperations.connectExpert.pending, handlePending)
      //   .addCase(partnersOperations.connectExpert.fulfilled, (state, action) => {
      //     // state.partnersList;
      //     state.onePartner = action.payload;
      //     state.isLoading = false;
      //     state.error = null;
      //   })
      //   .addCase(partnersOperations.connectExpert.rejected, handleRejected)

      .addCase(enumsOperations.updateEnum.pending, handlePending)
      .addCase(enumsOperations.updateEnum.fulfilled, (state, action) => {
        const { id, type } = action.meta.arg.dataBody;
        const updatedItem = action.payload;

        if (type === 'skills') {
          const index = state.enumsListSkills.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListSkills[index] = updatedItem;
        }
        if (type === 'categories') {
          const index = state.enumsListCategories.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListCategories[index] = updatedItem;
        }
        if (type === 'specializations') {
          const index = state.enumsListSpecializations.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListSpecializations[index] = updatedItem;
        }
        if (type === 'disorders') {
          const index = state.enumsListDisorders.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListDisorders[index] = updatedItem;
        }

        state.oneEnum = updatedItem;
        state.isLoading = false;
        state.error = false;
      })
      .addCase(enumsOperations.updateEnum.rejected, handleRejected)

      .addCase(enumsOperations.deleteEnum.pending, handlePending)
      .addCase(enumsOperations.deleteEnum.fulfilled, (state, action) => {
        const { id, type } = action.meta.arg;

        if (type === 'skills') {
          const index = state.enumsListSkills.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListSkills.splice(index, 1);
        }
        if (type === 'categories') {
          const index = state.enumsListCategories.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListCategories.splice(index, 1);
        }
        if (type === 'specializations') {
          const index = state.enumsListSpecializations.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListSpecializations.splice(index, 1);
        }
        if (type === 'disorders') {
          const index = state.enumsListDisorders.findIndex(
            item => item._id === id
          );
          if (index !== -1) state.enumsListDisorders.splice(index, 1);
        }

        state.isLoading = false;
        state.error = false;
      })
      .addCase(enumsOperations.deleteEnum.rejected, handleRejected);
  },
});

export const { setError, partnersClearError } = enumsSlice.actions;

export default enumsSlice.reducer;
